/* Gearance — Scroll Reveal + Hero Animations */
(function () {
  'use strict';

  // --- Scroll Reveal via Intersection Observer ---
  function initReveal() {
    const els = document.querySelectorAll('.g-reveal');
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    els.forEach((el) => io.observe(el));
  }

  // --- Hero Ken Burns (subtle zoom-out on load) ---
  function initHero() {
    const hero = document.querySelector('.gearance-hero');
    if (!hero) return;
    requestAnimationFrame(() => {
      hero.classList.add('loaded');
    });
  }

  // --- Marquee duplicate for seamless loop ---
  function initMarquee() {
    document.querySelectorAll('.marquee__list').forEach((list) => {
      if (list.dataset.gDone) return;
      list.dataset.gDone = '1';
      const clone = list.cloneNode(true);
      list.parentNode.appendChild(clone);
    });
  }

  // --- Init ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initReveal();
      initHero();
      initMarquee();
    });
  } else {
    initReveal();
    initHero();
    initMarquee();
  }
})();
